import { BUILTIN_PROVIDERS, BUILTIN_PROVIDER_METADATA } from "./builtinProviders";

export const createProviderRegistry = (initial = BUILTIN_PROVIDERS) => {
  const providers = { ...initial };

  return {
    get: (name) => providers[name],

    register: (name, fn) => {
      providers[name] = fn;
    },

    toMap: () => ({ ...providers }),

    names: () => Object.keys(providers),
  };
};

export const defaultRegistry = createProviderRegistry();

export { BUILTIN_PROVIDER_METADATA };
